export const SUCCESS = 'snackbar-success';
export const ERROR = 'snackbar-error';